import React from 'react';
import { Button } from 'antd';
import { ExternalLink } from 'lucide-react';
import { getApiErrorConfig } from '../config';
import { ApiErrorContentProps } from '../types';
import { useNavigate } from 'react-router';

export const ApiErrorContent: React.FC<ApiErrorContentProps> = ({
  error,
  title,
  description,
  retryButtonText = 'Try Again',
  showHelpButton = true,
  onRetry,
  onClose,
}) => {
  const config = getApiErrorConfig(error.type);
  const navigate = useNavigate();

  if (error.isAuthError) {
    retryButtonText = 'Log in';
    onRetry = () => {
      navigate('/login', {
        state: { redirect_url: window.location.pathname },
      });
    };
  }

  const handleRetry = () => {
    onRetry?.();
    onClose?.();
  };

  const handleReportIssue = () => {
    window.open('https://support.arcsite.com/', '_blank');
    onClose?.();
  };

  return (
    <div className="flex flex-col items-center justify-center py-4">
      <div className="mb-4">{config.icon}</div>

      <h2 className="text-lg font-semibold text-gray-900 mb-2 text-center">
        {title || config.title}
      </h2>

      <p className="text-sm text-gray-500 mb-6 text-center max-w-sm">
        {description || config.getDescription(error)}
      </p>

      <div className="flex gap-3 w-full max-w-sm">
        {showHelpButton && (
          <Button
            icon={<ExternalLink className="h-4 w-4" />}
            onClick={handleReportIssue}
            className="flex-1"
          >
            Report Issue
          </Button>
        )}

        <Button
          type="primary"
          onClick={handleRetry}
          className={showHelpButton ? 'flex-1' : 'w-full'}
        >
          {retryButtonText}
        </Button>
      </div>
    </div>
  );
};
